import type { MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';

import type { AtlassianTeamUpdateArchiveHydratedAction } from '../types';

export function isActionReadonly(
	action: AtlassianTeamUpdateArchiveHydratedAction,
	getReadonly: (action: MessageAction) => boolean,
): boolean {
	return getReadonly(action) || action.data.state !== 'ACTIVE';
}

export function isActionResolved(
	action: AtlassianTeamUpdateArchiveHydratedAction,
	getStatus: (action: MessageAction) => string,
): boolean {
	const status = getStatus(action);
	const actionStatus = action.status;
	const isResolved = (status: string | undefined) =>
		status === 'cancelled' || status === 'finished' || action.data.state !== 'ACTIVE';
	return isResolved(status) || isResolved(actionStatus);
}

export function isActionErrored(
	action: MessageAction,
	getStatus: (action: MessageAction) => string,
): boolean {
	return getStatus(action) === 'errored' || action.status === 'errored';
}

export function isActionFinished(
	action: AtlassianTeamUpdateArchiveHydratedAction,
	getStatus: (action: MessageAction) => string,
): boolean {
	return (
		getStatus(action) === 'finished' ||
		action.status === 'finished' ||
		action.data.state !== 'ACTIVE'
	);
}
